export default function Partners() {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Seja Nosso Parceiro
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
              Seja um pólo de cursos do ICMI e abençoe sua igreja ou mesmo a sua região! Conheça nossa proposta para coordenadores de pólos.
            </p>
            
            <div className="max-w-2xl mx-auto mb-12">
              <div className="w-full h-80 rounded-lg overflow-hidden shadow-lg">
                <img
                  src="https://static.readdy.ai/image/80821a7127edf6626cb7d3e082946c04/0ba023090dc6143e262f8928c1aaa455.jpeg"
                  alt="Coordenadores de pólos do ICMI"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-r from-teal-50 to-teal-100 rounded-lg p-8 text-center">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Entre em Contato
            </h3>
            <p className="text-gray-700 mb-6 max-w-2xl mx-auto">
              Se sua igreja deseja estabelecer uma parceria com o ICMI para capacitar seus líderes, entre em contato conosco
            </p>
            <a
              href="https://wa.me/5567992870208"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-teal-600 text-white px-8 py-3 rounded-lg font-medium hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-handshake-line text-xl"></i>
              Tornar-se Parceiro
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
